/**
 * First-screen media control: one viewport video at a time,
 * deferred mega-menu product cards, deferred inactive tabs.
 */
(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
  var stylesheetInjected = false;

  function injectStyles() {
    if (stylesheetInjected) return;
    stylesheetInjected = true;
    var style = document.createElement('style');
    style.textContent =
      '.js-lazy-media{position:relative;width:100%;height:100%;}' +
      '.js-lazy-media .lazy-media-poster,.js-lazy-media picture,.js-lazy-media video.lazy-media-el{' +
      'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;}' +
      '.js-lazy-media.lazy-media-playing .lazy-media-poster,.js-lazy-media.lazy-media-playing picture{opacity:0;pointer-events:none;}' +
      '.js-defer-nav-products{display:none;}';
    document.head.appendChild(style);
  }

  function pickSource(el) {
    var isMobile = MOBILE_MQ.matches;
    var src = isMobile && el.dataset.mobileSrc ? el.dataset.mobileSrc : el.dataset.pcSrc || el.dataset.mobileSrc;
    var type = isMobile && el.dataset.mobileSrc ? el.dataset.mobileType : el.dataset.pcType || el.dataset.mobileType;
    var poster = isMobile && el.dataset.mobilePoster ? el.dataset.mobilePoster : el.dataset.pcPoster || el.dataset.mobilePoster;
    return { src: src, type: type || 'video/mp4', poster: poster };
  }

  function createVideo(el) {
    if (!el || el.querySelector('video.lazy-media-el')) return;
    var picked = pickSource(el);
    if (!picked.src) return;

    var video = document.createElement('video');
    video.className = 'lazy-media-el img-fit';
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.preload = el.dataset.mode === 'slideshow' ? 'auto' : 'metadata';
    if (picked.poster) video.poster = picked.poster;

    var source = document.createElement('source');
    source.src = picked.src;
    source.type = picked.type;
    video.appendChild(source);
    el.appendChild(video);

    if (el.dataset.autoplay !== 'false') {
      video.autoplay = true;
      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.then === 'function') {
        playAttempt
          .then(function () {
            el.classList.add('lazy-media-playing');
          })
          .catch(function () {});
      }
    }
  }

  function destroyVideo(el) {
    if (!el) return;
    var videos = el.querySelectorAll('video.lazy-media-el');
    if (!videos.length) return;
    videos.forEach(function (video) {
      video.pause();
      video.removeAttribute('src');
      video.querySelectorAll('source').forEach(function (source) {
        source.removeAttribute('src');
      });
      video.load();
      video.remove();
    });
    el.classList.remove('lazy-media-playing');
  }

  function pauseVideo(el) {
    var video = el && el.querySelector('video.lazy-media-el');
    if (!video) return;
    video.pause();
    el.classList.remove('lazy-media-playing');
  }

  function syncSlideshow(root) {
    var scope = root || document;
    scope.querySelectorAll('.js-lazy-media[data-mode="slideshow"]').forEach(function (media) {
      var slide = media.closest('.slideshow__slide');
      if (!slide) {
        createVideo(media);
        return;
      }
      if (slide.classList.contains('is-active')) {
        createVideo(media);
      } else {
        destroyVideo(media);
      }
    });
  }

  function initViewportMedia() {
    var nodes = document.querySelectorAll('.js-lazy-media[data-mode="viewport"]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(createVideo);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            createVideo(entry.target);
          } else {
            pauseVideo(entry.target);
          }
        });
      },
      { rootMargin: '120px 0px' }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function initClickMedia() {
    document.addEventListener(
      'click',
      function (event) {
        var playBtn = event.target.closest && event.target.closest('.play_icon_wrap');
        if (!playBtn) return;
        var section = playBtn.closest('.video-section, .section-video-youtube');
        if (!section) return;
        section.querySelectorAll('.js-lazy-media[data-mode="click"]').forEach(createVideo);
      },
      true
    );
  }

  function hydrateTemplates(root, selector) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(selector).forEach(function (tpl) {
      if (!tpl.content || tpl.dataset.hydrated === 'true') return;
      tpl.dataset.hydrated = 'true';
      tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
      tpl.remove();
    });
  }

  function hydrateDeferredNav(root) {
    hydrateTemplates(root || document, 'template.js-defer-nav-products');
  }

  function hydrateTabContent(tabContent) {
    if (!tabContent) return;
    hydrateTemplates(tabContent, 'template.js-defer-tab-content');
  }

  function initDeferredNav() {
    function maybeHydrate(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var mega = target.closest('.js-mega-nav');
      var mount =
        target.closest('.nav-item-cont') ||
        target.closest('.pc-real-product-list .disclosure__panel.active') ||
        (mega &&
          (mega.querySelector('.pc-real-product-list .disclosure__panel.active') ||
            mega.querySelector('.disclosure__panel.active'))) ||
        target.closest('.disclosure__panel') ||
        target.closest('details[open]');
      if (!mount) return;
      hydrateDeferredNav(mount);
    }

    document.addEventListener('pointerenter', maybeHydrate, true);
    document.addEventListener('focusin', maybeHydrate, true);
    document.addEventListener('click', maybeHydrate, true);
  }

  function initDeferredTabs() {
    document.addEventListener(
      'click',
      function (event) {
        var tabItem = event.target.closest && event.target.closest('.tab-item');
        if (!tabItem) return;
        requestAnimationFrame(function () {
          var root = tabItem.parentElement && tabItem.parentElement.parentElement;
          if (!root) return;
          var active = root.querySelector('.tab-content.is-active');
          hydrateTabContent(active);
        });
      },
      true
    );
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  window.syncSlideshowLazyMedia = syncSlideshow;
  window.hydrateDeferredNavProducts = hydrateDeferredNav;

  onReady(function () {
    injectStyles();
    syncSlideshow(document);
    initViewportMedia();
    initClickMedia();
    initDeferredNav();
    initDeferredTabs();
  });

  if (MOBILE_MQ.addEventListener) {
    MOBILE_MQ.addEventListener('change', function () {
      document.querySelectorAll('.js-lazy-media').forEach(function (el) {
        var video = el.querySelector('video.lazy-media-el');
        if (!video) return;
        destroyVideo(el);
        var slide = el.closest('.slideshow__slide');
        var shouldPlay =
          el.dataset.mode !== 'slideshow' || !slide || slide.classList.contains('is-active');
        if (shouldPlay) createVideo(el);
      });
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    injectStyles();
    syncSlideshow(event.target);
    initViewportMedia();
  });
})();
